import React from 'react';

class TestimonialCard extends React.Component {
  render() {
    const { customer_name, license_type, rating, quote, product_name } = this.props.testimonial;
    return (
      <div className="testimonial-card">
        <div className="stars">{'★'.repeat(rating || 5)}{'☆'.repeat(5 - (rating || 5))}</div>
        <p className="quote">&ldquo;{quote}&rdquo;</p>
        <div className="testimonial-meta">
          <div>
            <strong>{customer_name}</strong>
            {product_name && <span className="testimonial-product">{product_name}</span>}
          </div>
          <span className={`badge badge-${license_type}`}>
            {license_type === 'shared' ? 'Shared license' : 'Private license'}
          </span>
        </div>
      </div>
    );
  }
}

export default TestimonialCard;
